// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23h5U","list":"styles_list__1Wdbb","disableSelection":"styles_disableSelection__22brw"};